export const AssetsSvgCurrencyMap = {
    ic_aed: 'ic_aed',
    ic_amd: 'ic_amd',
    ic_azn: 'ic_azn',
    ic_bgn: 'ic_bgn',
    ic_bob: 'ic_bob',
    ic_byn: 'ic_byn',
    ic_chf: 'ic_chf',
    ic_cny: 'ic_cny',
    ic_czk: 'ic_czk',
    ic_default_currency: 'ic_default_currency',
    ic_dkk: 'ic_dkk',
    ic_eur: 'ic_eur',
    ic_gbp: 'ic_gbp',
    ic_gel: 'ic_gel',
    ic_huf: 'ic_huf',
    ic_idr: 'ic_idr',
    ic_kzt: 'ic_kzt',
    ic_mdl: 'ic_mdl',
    ic_mxn: 'ic_mxn',
    ic_myr: 'ic_myr',
    ic_nok: 'ic_nok',
    ic_php: 'ic_php',
    ic_pln: 'ic_pln',
    ic_ron: 'ic_ron',
    ic_rsd: 'ic_rsd',
    ic_rub: 'ic_rub',
    ic_sek: 'ic_sek',
    ic_sgd: 'ic_sgd',
    ic_try: 'ic_try',
    ic_uah: 'ic_uah',
    ic_usd: 'ic_usd',
};
export const AssetsImages: { [key: string]: TAssetImage } = {
    ic_add_to_apple_pay: { name: 'ic_add_to_apple_pay', width: 126, height: 40 },
    ic_add_to_google_pay: { name: 'ic_add_to_google_pay', width: 145, height: 40 },
    ic_apple_pay: { name: 'ic_apple_pay', width: 40, height: 40 },
    ic_apple_pay_small: { name: 'ic_apple_pay_small', width: 32, height: 24 },
    ic_apple_pay_small_opacity: { name: 'ic_apple_pay_small_opacity', width: 33, height: 24 },
    ic_google_pay_small: { name: 'ic_google_pay_small', width: 38, height: 24 },
    ic_google_pay_small_opacity: { name: 'ic_google_pay_small_opacity', width: 38, height: 24 },
    mastercard: { name: 'mastercard', width: 40, height: 24 },
    mastercard_white_opacity: { name: 'mastercard_white_opacity', width: 36, height: 22 },
    paysend: { name: 'paysend', width: 21, height: 27 },
};

export type TAssetImage = {
    name: string;
    width: number;
    height: number;
};

export const AssetsPaySystemsMap = {
    paysystem_amex: 'paysystem_amex',
    paysystem_arca: 'paysystem_arca',
    paysystem_discover: 'paysystem_discover',
    paysystem_elcart: 'paysystem_elcart',
    paysystem_humo: 'paysystem_humo',
    paysystem_kortimilli: 'paysystem_kortimilli',
    paysystem_mastercard: 'paysystem_mastercard',
    paysystem_mir: 'paysystem_mir',
    paysystem_napas: 'paysystem_napas',
    paysystem_troy: 'paysystem_troy',
    paysystem_unionpay: 'paysystem_unionpay',
    paysystem_uzcard: 'paysystem_uzcard',
    paysystem_verve: 'paysystem_verve',
    paysystem_visa: 'paysystem_visa',
};
export const AssetsSvgIc = {
    ic_alert_circle_small: 'ic_alert_circle_small',
    ic_alert_fill: 'ic_alert_fill',
    ic_arrow_back: 'ic_arrow_back',
    ic_arrow_down: 'ic_arrow_down',
    ic_arrow_down_left: 'ic_arrow_down_left',
    ic_arrow_forward: 'ic_arrow_forward',
    ic_arrow_forward_circle: 'ic_arrow_forward_circle',
    ic_arrow_retry: 'ic_arrow_retry',
    ic_arrow_rounded_back: 'ic_arrow_rounded_back',
    ic_arrow_up: 'ic_arrow_up',
    ic_arrow_up_right: 'ic_arrow_up_right',
    ic_arrows_exchange: 'ic_arrows_exchange',
    ic_arrows_recurring: 'ic_arrows_recurring',
    ic_arrows_transfers: 'ic_arrows_transfers',
    ic_attachment: 'ic_attachment',
    ic_bag: 'ic_bag',
    ic_building: 'ic_building',
    ic_bank: 'ic_bank',
    ic_bank_bolt: 'ic_bank_bolt',
    ic_bell: 'ic_bell',
    ic_bell_ringing: 'ic_bell_ringing',
    ic_box_with_link: 'ic_box_with_link',
    ic_camera: 'ic_camera',
    ic_card: 'ic_card',
    ic_card_id: 'ic_card_id',
    ic_card_plus: 'ic_card_plus',
    ic_cardp_plus: 'ic_cardp_plus',
    ic_cash: 'ic_cash',
    ic_check: 'ic_check',
    ic_check_20: 'ic_check_20',
    ic_check_circle: 'ic_check_circle',
    ic_check_circle_small: 'ic_check_circle_small',
    ic_check_circle_thin: 'ic_check_circle_thin',
    ic_chevron_down: 'ic_chevron_down',
    ic_chevron_down_big: 'ic_chevron_down_big',
    ic_chevron_down_small: 'ic_chevron_down_small',
    ic_chevron_right: 'ic_chevron_right',
    ic_chevron_right_big: 'ic_chevron_right_big',
    ic_chevron_up: 'ic_chevron_up',
    ic_chevron_up_big: 'ic_chevron_up_big',
    ic_clock_filled_small: 'ic_clock_filled_small',
    ic_clock_reversed: 'ic_clock_reversed',
    ic_clock_square: 'ic_clock_square',
    ic_clock_thin: 'ic_clock_thin',
    ic_cloud: 'ic_cloud',
    ic_cloud_upload_medium: 'ic_cloud_upload_medium',
    ic_coins: 'ic_coins',
    ic_copy: 'ic_copy',
    ic_document: 'ic_document',
    ic_dots: 'ic_dots',
    ic_dots_vertical: 'ic_dots_vertical',
    ic_dotted_list: 'ic_dotted_list',
    ic_eye: 'ic_eye',
    ic_eye_crossed: 'ic_eye_crossed',
    ic_filter: 'ic_filter',
    ic_ghost: 'ic_ghost',
    ic_gift: 'ic_gift',
    ic_globe: 'ic_globe',
    ic_id_card_thin: 'ic_id_card_thin',
    ic_info_circle: 'ic_info_circle',
    ic_info_circle_small: 'ic_info_circle_small',
    ic_life_buoy: 'ic_life_buoy',
    ic_logos: 'ic_logos',
    ic_menu: 'ic_menu',
    ic_passcode_dot: 'ic_passcode_dot',
    ic_paysend_circle: 'ic_paysend_circle',
    ic_paysend_circle_plus_medium: 'ic_paysend_circle_plus_medium',
    ic_paysend_circle_minus_medium: 'ic_paysend_circle_minus_medium',
    ic_pdf: 'ic_pdf',
    ic_pencil: 'ic_pencil',
    ic_people: 'ic_people',
    ic_person: 'ic_person',
    ic_person_camera_medium: 'ic_person_camera_medium',
    ic_person_medium: 'ic_person_medium',
    ic_picture: 'ic_picture',
    ic_image: 'ic_picture',
    ic_placeholder: 'ic_placeholder',
    ic_plus: 'ic_plus',
    ic_plus_circle: 'ic_plus_circle',
    ic_plus_minus: 'ic_plus_minus',
    ic_minus: 'ic_minus',
    ic_power: 'ic_power',
    ic_scissors: 'ic_scissors',
    ic_search: 'ic_search',
    ic_settings: 'ic_settings',
    ic_shopping_bag: 'ic_shopping_bag',
    ic_share: 'ic_share',
    ic_snowflake: 'ic_snowflake',
    ic_snowflake_crossed: 'ic_snowflake_crossed',
    ic_speedometer: 'ic_speedometer',
    ic_speedometer_2: 'ic_speedometer_2',
    ic_trash: 'ic_trash',
    ic_truck: 'ic_truck',
    ic_unlocked: 'ic_unlocked',
    ic_user_check: 'ic_user_check',
    ic_wallet: 'ic_wallet',
    ic_x: 'ic_x',
    ic_x_circle: 'ic_x_circle',
    ic_x_circle_thin_80: 'ic_x_circle_thin_80',
    ic_x_circle_small: 'ic_x_circle_small',
    ic_x_circle_thin: 'ic_x_circle_thin',
    ic_face_id: 'ic_face_id',
    ic_wait_fill: 'ic_wait_fill',
    ic_checkmark_fill: 'ic_checkmark_fill',
    ic_info_fill: 'ic_info_fill',
    ic_x_fill: 'ic_x_fill',
    ic_chart_crypto: 'ic_chart_crypto',
    ic_alert_triangle: 'ic_alert_triangle',
    ic_language: 'ic_language',
    ic_card_attention: 'ic_card_attention',
    ic_chat: 'ic_chat',
};

export const AssetsSvgMap = {
    ...AssetsSvgIc,
    ...AssetsSvgCurrencyMap,
};
export type TAssetsSvgMapValue = (typeof AssetsSvgMap)[keyof typeof AssetsSvgMap];
